import { render, staticRenderFns } from "./index.vue?vue&type=template&id=24e0ff8b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=24e0ff8b&prod&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=24e0ff8b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e0ff8b",
  null
  
)

export default component.exports